export const defaultOrgTeams = [
  { org: '인사본부', team: '인사팀' },
  { org: '트랙터기획담당', team: '트랙터본부기획팀' },
  { org: '트랙터기획담당', team: '트랙터법인지원팀' },
  { org: '트랙터기획담당', team: 'S&OP파트' },
  { org: '트랙터기획담당', team: '트랙터PMO' },
] as const;

export const APP_ID = 'performance-feedback-v1';
